import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { BeaconQueryFilterDto } from '../dto/beacon-query-filter.dto';
import { cleanEmptyValues } from '../../../shared/utils/functions.util';
import { ApiResponse } from '../../../shared/models/http';
import { BeaconProjectionDto } from '../dto/beacon-projection.dto';
import { UpdateBeaconDto } from '../dto/update-beacon.dto';

@Injectable({
  providedIn: 'root',
})
export class BeaconService {
  private url = `${environment.api}/spook/beacon`;

  constructor(
    private _http: HttpClient
  ) {}

  getBeacons(filters: BeaconQueryFilterDto): Observable<ApiResponse<BeaconProjectionDto[]>> {
    const cleanedFilters = cleanEmptyValues(filters);
    return this._http.get<ApiResponse<BeaconProjectionDto[]>>(this.url, { params: cleanedFilters });
  }

  updateBeacon(id: string, beacon: UpdateBeaconDto): Observable<ApiResponse<BeaconProjectionDto>> {
    return this._http.put<ApiResponse<BeaconProjectionDto>>(`${this.url}/${id}`, beacon);
  }
}
